import React from "react";
import { WattpadEmailAuthenticationButton } from "./WattpadEmailAuthenticationButton";
import { GoogleSSOButton } from "./GoogleSSOButton";
import { FacebookSSOButton } from "./FacebookSSOButton";
import SectionDivider from "./SectionDivider";
import { SwitchAuthenticationActionButton } from "./SwitchAuthenticationActionButton";
import PropTypes from "prop-types";
import { useTrans } from "../../../hooks";
import { sendSignupLandingEvent } from "@wattpad/client-platform-web-events";
import { FORM_VIEW } from "../constants";

const handleEmailAuthenticationClick = setAuthFormView => {
  sendSignupLandingEvent("email");
  setAuthFormView(FORM_VIEW.REGISTER);
};

export const AuthenticationOptions = ({
  setAuthFormView = () => {},
  nextUrl
}) => {
  const { trans } = useTrans();

  return (
    <div className={"authentication-options"}>
      <div className={"authentication-buttons-container"}>
        <WattpadEmailAuthenticationButton
          action={"signup"}
          handleClick={() => handleEmailAuthenticationClick(setAuthFormView)}
        />
        <GoogleSSOButton action={"signup"} nextUrl={nextUrl} />
        <FacebookSSOButton action={"signup"} />
      </div>
      <SectionDivider text={trans("or")} />
      <SwitchAuthenticationActionButton
        action={"signup"}
        setAuthFormView={setAuthFormView}
      />
    </div>
  );
};

AuthenticationOptions.propTypes = {
  nextUrl: PropTypes.string,
  setAuthFormView: PropTypes.func
};
